import moment from 'moment';
import { apiGateway } from '../api';

const DATE_FORMAT_API = 'MM/DD/YYYY H:mm:ss';

async function getReferenciaMovimentacao(numContrato) {
    try {
        const response = await apiGateway.get(`/contratos/${numContrato}/movimentacoes/referencia`);

        response.data.dataReferenciaMovimentacao = moment(
            response.data.dataReferenciaMovimentacao,
            DATE_FORMAT_API
        ).toISOString();
        response.data.dataLimiteEnvio = moment(response.data.dataLimiteEnvio, DATE_FORMAT_API).toISOString();
        response.data.dataInclusao = moment(response.data.dataInclusao, DATE_FORMAT_API).toISOString();
        response.data.dataExclusao = moment(response.data.dataExclusao, DATE_FORMAT_API).toISOString();

        return response.data;
    } catch (error) {
        return error;
    }
}

export { getReferenciaMovimentacao };
